<template>
  <vx-card
    class="h-full hive-list__hive_card"
    :class="userRole === 'tenant_master' && hive.user.id !== userInfo.user_id ? '' : 'hive-list__hive_card-hover cursor-pointer'"
    @click="goChartData(hive)"
  >
    <div slot="no-body" class="h-full flex justify-end flex-column ">
      <div class="p-4">
        <div class="flex items-center mb-3">
          <div class="hive_card_hive_name mb-0 text-warning text-truncate">{{ hive.name }}</div>
        </div>
        <div class="mb-5">
          <div class="h6 text-muted text-truncate mb-1">{{ hive.apiary }}</div>
          <div
            class="h6 text-muted text-truncate"
            v-if="userRole !== 'user'"
          >
            {{ hive.user.company ? hive.user.company : "" }}
            {{ hive.user.company && hive.user.first_name ? "-" : "" }}
            {{
              hive.user.first_name
                ? hive.user.first_name + " " + hive.user.last_name
                : ""
            }}
          </div>
        </div>
        <div class="font-size-13">
          <div class="mb-2">
            <div >{{ $t("hives.Bee") }}</div>
            <div class="font-bold text-truncate">
              {{ hive.bee_type ? hive.bee_type.name : "--" }}
            </div>
          </div>
          <div class="">
            <div>{{ $t("hives.detail.HiveType") }}</div>
            <div class="font-bold text-truncate">
              {{ hive.hive_type ? hive.hive_type.name : "--" }}
            </div>
          </div>
        </div>
      </div>
      <div class="hive-list__hive_card_footer p-4 h-full flex justify-center flex-column">
          <div class="text-center">
            {{ $t("hives.detail.NoDeviceMessage") }}
          </div>
          <div
            class="flex justify-center text-center mt-4"
            v-if="hive.user.id === userInfo.user_id"
          >
            <vs-button
              class="text-white"
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click.stop="$router.push(`/hives/hive/edit/${  hive.id}`).catch(() => {})"
              >{{ $t("hives.detail.AddDevice") }}</vs-button
            >
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import HexasenseIcon from '../../../libs/icons/index.vue'
export default {
  components:{HexasenseIcon},
  props: {
    hive: {
      type: Object,
      require: true
    }
  },
  computed: {
    userRole () {
      return this.$store.getters.userRole
    },
    userInfo () {
      return this.$store.getters.returnUserInfo
    }
  },
  methods: {
    goChartData (hive) {
      if (this.userRole === 'tenant_master') {
        if (hive.user.id === this.userInfo.user_id) {
          this.$router.push(`/hives/hive/${hive.id}`)
        }
      } else {
        this.$router.push(`/hives/hive/${hive.id}`)
      }
    }
  }
}
</script>

<style lang="scss">
.hive-list__hive_card {
  .vx-card__collapsible-content {
    height: 100% !important;
  }
  .hive-list__hive_card_footer {
    border-top: 1px solid #dae1e7;
  }
  .hive_card_hive_name{
    font-size: 18px;
    font-family: inherit;
    font-weight: 500;
  }
}

.hive-list__hive_card-hover:hover {
  margin-top: -5px;
  margin-bottom: 5px;
}
</style>
